module.exports = __webpack_public_path__ + "static/img/C4D0003.33a1fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0003.jpg
// module id = G/Nd
// module chunks = 0